import React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { useLayout } from '../../../../context/LayoutContext';
import { useTickets } from '../../../../context/TicketsContext';

const TicketCard = ({ ticket, index }) => {
  const { theme } = useLayout();
  const { openTicketDetail } = useTickets();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  };

  // Indicadores de prioridad
  const getPriorityIndicators = () => {
    switch(ticket.priority) {
      case 'low':
        return (
          <>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-low`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
          </>
        );
      case 'medium':
        return (
          <>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-low`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-medium`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
          </>
        );
      case 'high':
        return (
          <>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-low`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-medium`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-high`}></span>
          </>
        );
      case 'critical':
        return (
          <>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-high`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-high`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-high`}></span>
          </>
        );
      default:
        return (
          <>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
            <span className={`GM__${theme}-indicator GM__${theme}-indicator-empty`}></span>
          </>
        );
    }
  };

  return (
    <Draggable draggableId={ticket.id} index={index}>
      {(provided, snapshot) => (
        <div
          className={`GM__${theme}-ticket-card ${snapshot.isDragging ? 'dragging' : ''}`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => openTicketDetail(ticket)}
        >
          <div className={`GM__${theme}-ticket-indicators`}>
            {getPriorityIndicators()}
          </div>
          <p className={`GM__${theme}-ticket-title`}>
            {ticket.title}
          </p>
          <div className={`GM__${theme}-ticket-actions`}>
            <div className={`GM__${theme}-ticket-icons`}>
              <span className={`GM__${theme}-ticket-icon`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 20h9"></path>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                </svg>
              </span>
              {ticket.comments && ticket.comments.length > 0 && (
                <span className={`GM__${theme}-ticket-icon`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </span>
              )}
              <span className={`GM__${theme}-ticket-icon`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </span>
            </div>
            <div className={`GM__${theme}-ticket-date`}>{formatDate(ticket.updated)}</div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default TicketCard;